import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getReferrerInfo, { GetReferrerInfoInput, GetReferrerInfoOutput } from '.';

type TrimmedGetReferrerInfoInput = Omit<GetReferrerInfoInput, 'dlVaultContract'>;

export type UseGetReferrerInfoQueryKey = [
  FunctionKey.GET_REFERRER_INFO,
  TrimmedGetReferrerInfoInput,
];

type Options = QueryObserverOptions<
  GetReferrerInfoOutput,
  Error,
  GetReferrerInfoOutput,
  GetReferrerInfoOutput,
  UseGetReferrerInfoQueryKey
>;

const useGetReferrerInfo = (input: TrimmedGetReferrerInfoInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_REFERRER_INFO, input],
    () => getReferrerInfo({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetReferrerInfo; 